export default __webpack_public_path__ + "static/media/subtitle.aeaada51.svg";